    import React, { useEffect, useState } from 'react';
    import myImage  from 'assets/img/dashboards/dashboard_banner.jpg';

    interface Slide {
      title: string;
      description: string;
    }

    interface TextCarouselProps {
      slides: Slide[];
    }

    const TextCarousel: React.FC<TextCarouselProps> = ({ slides }) => {
      const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

       useEffect(() => {
    // Set up an interval to advance the slide
    const interval = setInterval(() => {
      setCurrentSlideIndex((prevIndex) => 
        (prevIndex + 1) % slides.length
      );
    }, 5000); // Change slide every 5 seconds

    // Clean up the interval when the component unmounts
    return () => clearInterval(interval);
  }, [slides.length]); // The empty dependency array ensures this runs once on mount


      const nextSlide = () => {
        setCurrentSlideIndex((prevIndex) => (prevIndex + 1) % slides.length);
      };

      const prevSlide = () => {
        setCurrentSlideIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
      };

      return (
        // Carousel structure with text content and navigation
        <div id="default-carousel"
         style={{ 
            backgroundImage: `url(${myImage})`,
            backgroundSize: 'cover', // Optional: Adjust as needed
            backgroundRepeat: 'no-repeat', // Optional: Adjust as needed
            backgroundPosition: 'center', // Optional: Adjust as needed
            marginTop: '1px',
            borderRadius: '15px',
            zIndex: 1

            //height: '280px', // Optional: Set height and width for visibility
          //  width: '100%' 
          }}
          >
        <div className="relative h-56 overflow-hidden rounded-lg md:h-90"> 
          {/* Slide content */}
          <div className="flex transition-transform duration-500 ease-in-out"
               style={{ transform: `translateX(-${currentSlideIndex * 100}%)` }}>
            {slides.map((slide, index) => (
              <div key={index} className="w-full flex-shrink-0 p-4 text-center">
                <h2 className="text-2xl font-bold mb-2 text-gray-100">{slide.title}</h2>
                <div className="w-full max-w-md mx-auto bg-gray-800 bg-opacity-70 p-4 rounded">
                <p className="text-gray-100 ">{slide.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation buttons */}
          <button onClick={prevSlide} className="absolute left-5 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-1 rounded-full">
            &lt;
          </button>
          <button onClick={nextSlide} className="absolute right-5 top-1/2 -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full">
            &gt;
          </button>

          {/* Indicators (optional) */}
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex space-x-2">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlideIndex(index)}
                className={`w-3 h-3 rounded-full ${
                  index === currentSlideIndex ? 'bg-gray-800' : 'bg-gray-400'
                }`}
              ></button>
            ))}
          </div>
        </div>
        </div>
      );
    };

    export default TextCarousel;